import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
	ActivatedRoute,
	NavigationEnd,
	Router,
	Scroll
} from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class AppTitleService {
	constructor(
		private readonly titleService: Title,
		private readonly router: Router,
		private readonly activatedRoute: ActivatedRoute
	) {}
	setPageTitles(): void {
		const appTitle = this.titleService.getTitle();
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd || (event instanceof Scroll && event.routerEvent instanceof NavigationEnd)),
				map(() => this.activatedRoute),
				map((route) => {
					let childRoute = route;
					while (childRoute.firstChild) {
						childRoute = childRoute.firstChild;
					}

					return childRoute;
				}),
				switchMap((route) => route?.data)
			)
			.subscribe((data) => {
				if (!data?.hasCustomPageTitle) {
					this.titleService.setTitle(data?.title || appTitle);
				}
			});
	}
}
